import { createFileRoute } from "@tanstack/react-router";

import { DatasetsLayout } from "~/pages/datasets.layout";

export const Route = createFileRoute("/_app/datasets")({
  component: DatasetsLayout,
});
